export const limitNumberWithinRange = (num = 0, min: number, max: number) =>
  Math.min(Math.max(num, min), max)

// Get the value of a percentage within a range
export const getPercentValueOfRange = (
  percentage: number,
  max: number,
  min = 0
) => {
  const val = (max / 100) * percentage
  return limitNumberWithinRange(val, min, max)
}

// Get percentage from current number against a maximum number
export const getPercentage = (current: number, max: number, invert = false) =>
  invert ? 100 - (100 * current) / max : (100 * current) / max
